import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrollToTop from "./helpers/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsOfService from "./pages/TermsOfService";
import Services from "./pages/Service";
import DoNotSellMyInfo from "./pages/DoNotSellMyInfo";
import TcpaConsent from "./pages/TcpaConsent";

function App() {
  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route
            exact
            path={`${process.env.PUBLIC_URL + "/"}`}
            component={Home}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/home"}`}
            component={Home}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/about"}`}
            component={About}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/services"}`}
            component={Services}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/contact"}`}
            component={Contact}
          />
          <Route
            path={process.env.PUBLIC_URL + "/disclaimer"}
            component={Disclaimer}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/privacy-policy"}`}
            component={PrivacyPolicy}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/refund-policy"}`}
            component={RefundPolicy}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/terms-of-service"}`}
            component={TermsOfService}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/do-not-sell-my-info"}`}
            component={DoNotSellMyInfo}
          />
          <Route
            path={`${process.env.PUBLIC_URL + "/tcpa-consent"}`}
            component={TcpaConsent}
          />
        </Switch>
      </ScrollToTop>
    </Router>
  );
}

export default App;
